<template>
	<div class="wrapper">
		<side-bar>
			<template slot="links">
				<sidebar-link to="/dashboard" name="Dashboard" icon="ti-dashboard" />
				<sidebar-link
					to="/realtimepower"
					name="Real Time Power"
					icon="ti-timer"
				/>
				<sidebar-link to="/cost" name="Cost" icon="ti-credit-card" />
				<sidebar-link to="/comparison" name="Comparison" icon="ti-layers-alt" v-if="user.isAdmin || user.isSuperAdmin"/>
				<sidebar-link 
					to="/environment"
					name="Environment"
					icon="ti-map-alt"
					v-if="user !== null && (user.site==='Brook Green' || user.site==='Brook Green Updated')"
				/>
				<sidebar-link
					to="/carbon_footprint"
					name="Carbon Footprint"
					icon="ti-truck"
				/>
				<sidebar-link
					to="/hvac"
					name="HAVC Control"
					icon="ti-server"
					v-if="user !== null && (user.site==='Brook Green' || user.site==='Brook Green Updated')"
				/>
				<sidebar-link to="/admin" name="Admin" icon="ti-home" v-if="user.isAdmin || user.isSuperAdmin"/>
				<sidebar-link to="/status" name="Status" icon="ti-stats-down" v-if="user.isSuperAdmin"/>
			</template>
		</side-bar>
		<div class="main-panel">
			<top-navbar v-if="$mq == 'mobile'"></top-navbar>
			<SetPeriodTime v-if="!isAdmin"></SetPeriodTime>
			<dashboard-content @click.native="toggleSidebar"> </dashboard-content>
			<content-footer></content-footer>
		</div>
	</div>
</template>
<style lang="scss"></style>
<script>
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./MobileMenu";
import SetPeriodTime from "./SetPeriodTime";
import  TopNavbar from "./TopNavbar";
import { mapActions, mapGetters } from "vuex";

export default {
	components: {
		TopNavbar,
		ContentFooter,
		DashboardContent,
		MobileMenu,
		SetPeriodTime,
	},
	data() {
		return {
			isAdmin: false,
		};
	},
	computed: {
		...mapGetters({
			user: 'auth/getUser'
		})
	},
	beforeRouteUpdate(to, from, next) {
		this.isAdmin = to.meta.isAdmin;
		next();
	},
	created() {
		this.isAdmin = this.$router.currentRoute.meta.isAdmin;
	},
	methods: {
		toggleSidebar() {
			if (this.$sidebar.showSidebar) {
				this.$sidebar.displaySidebar(false);
			}
		},
	},
};
</script>
